module.exports = __webpack_public_path__ + "img/neck-endomorph-female.8f608f8c.svg";